// in questo file vengono definiti i coefficienti dei modelli (coeff) e i valori che le linee di separazione delle aree colorate del grafico assumono in corrispondenza dei modelli (references)

// coefficienti per a3
const clinical_stage_coeff = [
  [0, 0, 0, 0, 0],
  [ 0.34167063950143, 0.610953840470884, 0.745725585399689, 0.561103769507756, 0.882421888496798],
  [ 0.697103194973247, 0.590900747169829, 0.925369389309778, 0.86839751321909, 1.16916559964064],
  [ 0.218256990123752, 0.535299340415417, 0.818435709776721, 0.929435805612496, 1.39990021482784],
  [ 0.516054420754075, 0.971252380657985, 1.5235083600234, 1.40333972334414, 1.46716182065078]
];


export const coeff = {
  // intercetta
  intercept: [ -7.0081163020859, -9.22582457740742, -9.29090907772444, -10.011854941978, -11.2303757292867],
  // a1
  age: [ 0.041142049758271, 0.0544542001428115, 0.0409269613822512, 0.0405581683888098, 0.0516558798277514],
  // a2
  psa: [ 1.46178575955441, 1.81763217628516, 2.1566975372699, 2.16362448718273, 2.02742222808436],
  // a3 (inserire i valori in clinical_stage_coeff)
  stage: {
    T1a: clinical_stage_coeff[0],
    T1b: clinical_stage_coeff[0],
    T1c: clinical_stage_coeff[0],
    T2a: clinical_stage_coeff[1],
    T2b: clinical_stage_coeff[2],
    T2c: clinical_stage_coeff[3],
    T3a: clinical_stage_coeff[4],
    T3b: clinical_stage_coeff[4],
    T4: clinical_stage_coeff[4]
  },
  // a4
  positive_cores: [ 1.24695151687192, 0.513435423964616, 0, 0, 0],
  // a5
  high_gleason_cores: [ 1.11103798449987, 1.07064187647654, 0.984605421994934, 1.17092332116817, 1.30959431683615],
  // a6
  high_tumor_cores: [ 1.0512877323175, 0.766958170001641, 0, 0, 0],
  // a7
  tumor_positive_mean: [ 1.30393670028131, 1.8800310406749, 2.98256236442865, 3.07671904062685, 2.79133182210326],
};

export const references = [
  // L1
  [ 0.0443199776190423, 0.0254934066809609, 0.0216152311166425, 0.0168528474039445, 0.0155288626556176],
  // L2
  [ 0.0742204978741965, 0.0600507753817537, 0.0475980983526835, 0.0378660483383425, 0.0437277170122289],
  // L3
  [ 0.127092686486032, 0.139114629504192, 0.199508428596659, 0.32966548885555, 0.438719150673444],
  // L4
  [ 0.211175010193566, 0.29366100331749, 0.504429270387968, 0.598754725594503, 0.707808387412397],
];



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/